const getDefaultState = () => {
  return {
    isLogged: false,
    user: null,
    initials: null,
  };
};

export default {
  SET_LOGGED: (state, isLogged) => (state.isLogged = isLogged),
  SET_USER: (state, user) => (state.user = user),
  SET_INITIALS: (state, initials) => (state.initials = initials),
  RESET_STATE: (state) => Object.assign(state, getDefaultState()),
};
